import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
    value: { accounts: [], selectedAccount: "" },
    status: 'idle', // idle | loading | succeeded | failed
    error: null
};

export const gtmSlice = createSlice({
    name: "gtm",
    initialState,
    reducers: {
        update: (state, action) => {
            state.value = action.payload;
        },
        updateSelectedAccount:(state,action)=>{
            state.value.selectedAccount = action.payload;
        }
    },
});

export const { update } = gtmSlice.actions;
// Export the reducer
export default gtmSlice.reducer;